<template>
	<div class="containerMain modal">
		<div class="row collegeFinder">
			<div class="row finder">
				<b-form-input v-model="textFilterInputValue" placeholder="Escribe para filtrar" :autofocus="true"/>
			</div>
		</div>
		<hr>
		<div class="row left colleges">
			<div v-b-tooltip.hover :title="school.name"  v-if="schoolsToRender.length > 0" class="college" v-for="school in schoolsToRender"  :key="school.schoolId" @click="selectSchool(school)">
				<div class="collegeTitle">{{school.name}}</div>
				<span class="collegeCity" v-if="school.addresses && school.addresses.length > 0">
					{{school.addresses[0].county.name}}, {{school.addresses[0].state.name}}, {{school.country.isoCodeTwo}}
				</span>
				<span class="collegeCity" v-else-if="school.country.name">
					{{school.country.isoCodeTwo}}
				</span>
			</div>
			<div v-if="schoolsToRender.length == 0">No se encontro ningún colegio.</div>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';
export default {
	timeoutFilter: null,
	filteredItems: null,
	data () {
		return {
			textFilterInputValue: '',
			textFilterQuery: ''
		};
	},
	watch: {
		textFilterInputValue () {
			clearTimeout(this.timeoutFilter);

			if (this.textFilterInputValue === '' || this.textFilterInputValue.length < 3) {
				this.textFilterQuery = '';
				return;
			}

			this.timeoutFilter = setTimeout(() => {
				this.textFilterQuery = this.textFilterInputValue;
			}, 750);
		}
	},
	computed: {
		schools () {
			return this.$store.state.persistent.schools;
		},
		schoolsToRender () {
			if (!this.schools) return [];
			if (!this.filtersApplied) return this.schools;

			const filteredItems = this.schools.filter((item) => {
				let match = true;
				if (this.textFilterQuery) match = helpers.textFilter.matchStringFromQuery(this.textFilterQuery, JSON.stringify(item));
				return match;
			});

			return filteredItems;
		},
		filtersApplied () {
			return (
				this.textFilterQuery !== ''
			);
		}
	},
	methods: {
		selectSchool (school) {
			this.$emit('closeModal');
			mediator.coaching.setSchool(school);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "../../scss/global.scss";
.college {
	background-color: $blank;
	border-radius: 0.2rem;
	box-shadow: 0 0.1rem 0.3rem 0.1rem $oxfordBlue;
	display: flex;
	flex-direction: column;
	padding: 1.8rem 1.2rem;
	margin: 1rem auto;
	width: 32%;
	height: 8rem;
	&>span {
		margin-top: 0.4rem;
	}
	&Finder {
		padding: 1rem 0;
		margin: 2rem 0;
		width: 100%;
	}
	&Title {
		font-size: $regularSize;
		color: $accentBlue;
		width: 27rem;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		&.bold {
			font-size: $mediumTitle;
			font-weight: 700;
			color: $oxfordBlue;
			width: 10%;
		}
	}
	&:hover {
		box-shadow: 0 0 0.2rem 0 $oxfordBlue;
		cursor: pointer;
	}
	&:active {
		border: 0.1rem solid $silkBlue;
		box-shadow: 0 0 0 0 $oxfordBlue;
		cursor: pointer;
	}
	&City {
		font-size: $tinySize;
		color: $semiBlack;
		font-weight: 700;
		align-self: flex-end;
	}
}
@media only screen and (max-width: 1200px) {
	.college {
		&Title {
			width: 36rem;
		}
	}
}
@media only screen and (max-width: 1200px) {
	.college {
		&Title {
			width: 34rem;
			&.bold {
				width: 15%;
			}
		}
	}
}
@media only screen and (max-width: 1199px) {
	.college {
		width: 48%;
		&Title {
			width: 40rem;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/ui/SchoolSelecter.vue